export enum Currency {
  Usd = "USD",
}

export const formatCurrency = (
  currency: Currency,
  value?: string | null,
  fractionDigits?: number
) => {
  if (!value) return "";

  if (!currency) {
    currency = Currency.Usd;
  }

  const formatters = {
    [Currency.Usd as string]: numberToUsdDollars,
  };

  const valueAsNumber = currencyStringToNumber(value);

  if (!formatters[currency]) {
    console.error(`Unsupported Currency: ${currency}`);
    return `${value} ${currency}`;
  }

  return formatters[currency]({ value: valueAsNumber, fractionDigits });
};

const numberToUsdDollars = ({
  value,
  fractionDigits,
}: {
  value: number;
  fractionDigits?: number;
}): string => {
  const locale = { region: "en-US", currency: "USD" };
  const formatter = new Intl.NumberFormat(locale.region, {
    style: "currency",
    currency: locale.currency,
    minimumFractionDigits: fractionDigits !== undefined ? fractionDigits : 2,
    maximumFractionDigits: fractionDigits !== undefined ? fractionDigits : 20, //Maximum value allowed by NumberFormat
  });

  return formatter.format(value);
};

const currencyStringToNumber = (value: string = ""): number =>
  Number(value.replace(/[^0-9.-]+/g, ""));
